<template>
  <div>
    <Card v-if="!!qbEstiamteInstance">
      <div>TxnId: {{ qbEstiamteInstance.external_object_id }}</div>
      <div>Created: {{ qbEstiamteInstance.created_at }}</div>
    </Card>
    <div v-else>{{ $t('empty_data') }}</div>
    <div class="text-align-right">
      <Button size="small" type="warning" @click="handleSend2QBOClicked" :loading="sendingOrder">{{ $t('order.send_order_to_qbo') }}</Button>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: "QuickBooksEstiamteLinks",
  props: {
    orderData: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false
    }
  },
  computed: {
    qbEstiamteInstance () {
      return this.orderData.external_object_relation
        ? this.orderData.external_object_relation.find(x => x.external_object_type === 'estimate')
        : false
    }
  },
  data () {
    return {
      sendingOrder: false
    }
  },
  methods: {
    ...mapActions(['sendOrderToQBO']),
    handleSend2QBOClicked () {
      this.sendingOrder = true

      this.sendOrderToQBO(this.orderData.id)
        .then(resp => {
          this.orderData.qbo_estimate_synced = resp.data
          this.$Message.success('Order has been successfully send in QBO.')
          this.$router.go()
        })
        .catch(e => {
          this.$Message.error('Sorry, there is an error ocurred!')
        })
        .finally(() => {
          this.sendingOrder = false
        })
    }
  }
}
</script>
